export const orders = {
  title: 'Đơn hàng',
  orders: 'Đơn hàng',
  resourceName: 'Đơn hàng',
  orderManagement: 'Quản lý đơn hàng',
  searchCode: {
    label: 'Tìm theo mã, mã vận đơn',
    placeholder: 'Nhập mã đơn hàng hoặc mã vận đơn',
  },
  filter: {
    placeholder: 'Tìm kiếm đơn hàng',
    advancedFilter: 'Lọc nâng cao',
    code: 'Mã đơn hàng',
    name: 'Tên đơn hàng',
    subCustomerCode: 'Mã sub KH',
    subCustomerPlaceholder: 'Mã sub khách hàng',
    numberOfPack: 'Số kiện',
    customer: 'Khách hàng',
    fromWarehouse: 'Kho đi',
    toWarehouse: 'Kho đến',
    createdAtFrom: 'Ngày tạo từ',
    createdAtTo: 'Ngày tạo đến',
    clearFilter: 'Xóa lọc',
    search: 'Tìm kiếm',
  },
  fields: {
    id: 'ID',
    code: 'Mã',
    createdAt: 'Ngày tạo',
    updatedAt: 'Ngày cập nhật',
    status: 'Trạng thái',
    customerId: 'ID khách hàng',
    customerName: 'Tên khách hàng',
    customerCode: 'Mã khách hàng',
    orderCode: 'Mã đơn hàng',
    ladingCode: 'Mã vận đơn',
    customer: 'Khách hàng',
    shipments: 'Lô hàng',
    totalPack: 'Tổng số kiện',
    totalVolume: 'Tổng số khối (m³)',
    totalWeight: 'Tổng số cân (kg)',
    totalNumberOfPack: 'Tổng số kiện',
    fee: 'Phí (CN¥)',
    orderCreate: 'Ngày tạo đơn',
    notes: 'Ghi chú',
    actions: 'Hành động',
    domesticShippingFee: 'Phí vận chuyển nội địa',
    towingFee: 'Phí kéo xe',
    otherFee: 'Phí khác',
    createdBy: 'Người tạo',
    isUnofficialWay: 'Hàng tiểu ngạch',
  },
  form: {
    ladingCode: {
      label: 'Mã vận đơn',
      helperText: 'Nhập mã vận đơn cho đơn hàng',
      validate: 'Vui lòng nhập mã vận đơn',
    },
    notes: {
      label: 'Ghi chú của khách hàng',
      helperText: 'Nhập ghi chú của khách hàng',
      validate: 'Vui lòng nhập ghi chú của khách hàng',
    },
    totalNumberOfPack: {
      label: 'Tổng số kiện',
      helperText: 'Nhập tổng số kiện cho đơn hàng',
      validate: 'Vui lòng nhập tổng số kiện',
    },
    domesticShippingFee: {
      label: 'Phí vận chuyển nội địa',
      helperText: 'Nhập phí vận chuyển nội địa cho đơn hàng',
      validate: 'Vui lòng nhập phí vận chuyển nội địa',
    },
    towingFee: {
      label: 'Phí kéo xe',
      helperText: 'Nhập phí kéo xe cho đơn hàng (nếu có)',
      validate: 'Vui lòng nhập phí kéo xe',
    },
    otherFee: {
      label: 'Phí khác',
      helperText: 'Nhập bất kỳ phí nào khác cho đơn hàng (nếu có)',
      validate: 'Vui lòng nhập bất kỳ phí nào khác',
    },
    isUnofficialWay: {
      label: 'Hàng tiểu ngạch',
      helperText: 'Các lô hàng của đơn hàng này sẽ không được tính toán thông qua hệ thống và ở trong kho đích luôn',
      validate: 'Vui lòng nhập hàng tiểu ngạch',
    },
    sectionOrderInfo: 'Thông tin đơn hàng',
    sectionFee: 'Phí (CNY)',
    placeholderLadingCode: 'Nhập mã vận đơn',
    placeholderNotesOptional: 'Ghi chú (tùy chọn)',
    labelShippingFee: 'Phí vận chuyển',
    checkboxUnofficialWay: 'Đi đường tiểu ngạch',
  },
  detail: {
    tabShipments: 'Lô hàng',
    tabInfo: 'Thông tin chung',
    tabPrice: 'Giá',
    noImages: 'Chưa có ảnh',
    shipmentsListTitle: 'Danh sách lô hàng',
    addShipment: 'Thêm lô hàng',
    duplicateShipment: 'Nhân bản',
    editShipment: 'Chỉnh sửa lô hàng',
    noShipments: 'Không có lô hàng',
    totalShipments: 'Tổng: {total} lô hàng',
    price: {
      columnStt: 'STT',
      columnInfo: 'Thông tin',
      columnPacks: 'Số kiện',
      columnPriceByWeight: 'Giá theo cân',
      columnPriceByVolume: 'Giá theo thể tích',
      columnFinalPrice: 'Giá cuối',
      pricePerKg: 'Giá/kg',
      pricePerM3: 'Giá/m³',
      priceByWeight: 'Giá theo cân',
      priceByVolume: 'Giá theo thể tích',
      totalShipments: 'Tổng giá lô hàng:',
      domesticShippingFee: 'Phí vận chuyển nội địa:',
      towingFee: 'Phí kéo xe:',
      otherFee: 'Phí khác:',
      total: 'Tổng cộng:',
    },
  },
  inputManual: 'Nhập tay',
  systemCalculation: 'Hệ thống tính',
  numberOfVolume: 'Số khối',
  numberOfWeight: 'Số cân',
  domesticShippingFee: 'Phí vận chuyển nội địa',
  towingFee: 'Phí kéo xe',
  otherFee: 'Phí khác',
  import: {
    button: 'Import',
    title: 'Import đơn hàng',
    description: 'Chọn file XLSX (định dạng theo file mẫu).',
    noSheet: 'Không tìm thấy sheet trong file Excel',
    readError: 'Đọc file Excel thất bại',
    noData: 'Chưa có dữ liệu để import',
    hasError: 'Import có lỗi. Vui lòng kiểm tra dữ liệu.',
    success: 'Import đơn hàng thành công',
    successWithCounts: 'Import đơn hàng thành công. Đã tạo: {created}, Đã cập nhật: {updated}',
    failed: 'Import thất bại',
    savedSuccess: 'Đã lưu thành công',
    templateSheetName: 'Mẫu nhập đơn hàng',
    templateFileName: 'Mau_nhap_don_hang.xlsx',
    templateSuccess: 'Tải file mẫu thành công',
    templateFailed: 'Tải file mẫu thất bại',
    templateLoading: 'Đang tải...',
    templateButton: 'Tải file mẫu',
  },
  export: {
    button: 'Export',
    fileName: 'Danh_sach_don_hang_{date}.xlsx',
    sheetName: 'Danh sach don hang',
    success: 'Xuất file Excel thành công',
    failed: 'Xuất file Excel thất bại',
    loading: 'Đang xuất...',
    columns: {
      code: 'Mã đơn hàng',
      name: 'Tên đơn hàng',
      subCustomerCode: 'Mã sub KH',
      numberOfPack: 'Số kiện',
      customerName: 'Khách hàng',
      fromWarehouseName: 'Kho đi',
      toWarehouseName: 'Kho đến',
      createdAt: 'Ngày tạo',
      updatedAt: 'Ngày cập nhật',
    },
  },
  titles: {
    view: 'Chi tiết đơn hàng',
    show: 'Xem đơn hàng',
    edit: 'Sửa đơn hàng',
    create: 'Tạo đơn hàng',
    latestOrders: 'Đơn hàng gần nhất',
    duplicateOrder: 'Nhân bản đơn hàng',
    deleteOrder: 'Xóa đơn hàng',
    editOrder: 'Chỉnh sửa đơn hàng',
    addQuick: 'Thêm nhanh',
    deleteSelected: 'Xóa đã chọn',
    deleting: 'Đang xóa...',
    selectedCount: 'Đã chọn {count} đơn hàng',
  },
  messages: {
    saving: 'Đang lưu...',
    savedSuccess: 'Đã lưu thành công',
    loadOrderError: 'Không thể tải thông tin đơn hàng',
    deleteConfirm: 'Bạn có chắc muốn xóa đơn hàng này? Toàn bộ lô hàng thuộc đơn sẽ bị xóa.',
    deleteSuccess: 'Đã xóa đơn hàng',
    deleteError: 'Xóa đơn hàng thất bại',
    bulkDeleteConfirm: 'Xóa {count} đơn hàng đã chọn? Toàn bộ lô hàng thuộc các đơn sẽ bị xóa.',
    bulkDeleteError: 'Xóa hàng loạt thất bại',
    noData: 'Không có dữ liệu',
    totalOrders: 'Tổng: {total} đơn hàng',
  },
}
